// eslint-disable-next-line @typescript-eslint/no-var-requires
const {default: wrapPageElement} = require('./dist/plugin/wrap-page-element');

module.exports.wrapPageElement = wrapPageElement;
